/**
 * ISO 6346 Container-Nummer-Validierung inkl. Prüfziffer.
 * Format: 4 Buchstaben (3 Owner + Kategorie U/J/Z) + 6 Ziffern + 1 Prüfziffer.
 * Siehe docs/BACKLOG.md Ticket G1.
 */
const ISO6346_RE = /^[A-Z]{3}[UJZ]\d{6}\d$/;
// Buchstabenwerte nach ISO 6346 (A=10 … Z=38, Vielfache von 11 ausgelassen).
const LETTER_VALUES = (() => {
    const map = {};
    let value = 10;
    for (let i = 0; i < 26; i++) {
        const letter = String.fromCharCode(65 + i); // A..Z
        map[letter] = value;
        value++;
        if (value % 11 === 0)
            value++; // Vielfache von 11 überspringen
    }
    return map;
})();
/** Berechnet die ISO-6346-Prüfziffer für die ersten 10 Zeichen. */
export function computeCheckDigit(first10) {
    const chars = first10.toUpperCase().split('');
    let sum = 0;
    for (let i = 0; i < 10; i++) {
        const ch = chars[i];
        if (ch === undefined)
            throw new Error('Container-Nummer zu kurz');
        const v = /\d/.test(ch) ? Number(ch) : LETTER_VALUES[ch];
        if (v === undefined)
            throw new Error(`Ungültiges Zeichen: ${ch}`);
        sum += v * 2 ** i;
    }
    const remainder = sum % 11;
    return remainder === 10 ? 0 : remainder;
}
/**
 * Normalisiert eine Eingabe auf die kanonische Form: Großbuchstaben, **alle** Nicht-
 * Alphanumerischen entfernt (Leerzeichen, Punkt, Schrägstrich, Bindestrich …). Damit werden alle
 * gängigen Kunden-/Terminal-Schreibweisen vereinheitlicht, z. B.
 * `MAEU 123.456.7`, `MAEU123456/7`, `MAEU 123 456 / 7`, `MAEU-123456-7` → `MAEU1234567`.
 */
export function normalizeContainerNumber(input) {
    return (input ?? '').toUpperCase().replace(/[^A-Z0-9]/g, '');
}
/** Prüft Format und Prüfziffer einer Container-Nummer. */
export function isValidContainerNumber(input) {
    const value = normalizeContainerNumber(input);
    if (!ISO6346_RE.test(value))
        return false;
    const expected = computeCheckDigit(value.slice(0, 10));
    return expected === Number(value[10]);
}
/** Liefert das 4-stellige Präfix (Owner + Kategorie) oder null. */
export function getContainerPrefix(input) {
    const value = normalizeContainerNumber(input);
    return /^[A-Z]{4}/.test(value) ? value.slice(0, 4) : null;
}
//# sourceMappingURL=container-number.js.map